var _style, _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStockDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216 216",
    style: {
      enableBackground: "new 0 0 216 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2436E7;}\n\t.st1{fill:none;}\n\t.st2{fill:#8DC63F;}\n\t.st3{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180,107c0,38.1-30.9,69-69,69c-13.8,0-26.7-4.1-37.5-11.1c-1.6-1-3.2-2.2-4.7-3.3h0 C53,149.4,42.7,130.5,42,109.2c0-0.7,0-1.5,0-2.2c0-2.4,0.1-4.7,0.3-7c3.5-34.8,32.9-62,68.7-62c18.3,0,35,7.1,47.3,18.8 c1.5,1.4,2.8,2.8,4.2,4.3c3.9,4.4,7.3,9.3,10,14.6c1.1,2.1,2,4.2,2.9,6.4C178.3,89.8,180,98.2,180,107z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.8,161.6L68.8,161.6c1.5,1.2,3.1,2.3,4.7,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.3,82c-0.9-2.2-1.8-4.3-2.9-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.3,82l-32.4,54.7c-0.4,0.7-1.1,1.1-1.8,1.3c-0.8,0.2-1.6,0-2.2-0.4l-33.7-22.2l-31.7,49.5 c-1.6-1-3.2-2.2-4.7-3.3l33.1-51.7c0.4-0.6,1.1-1.1,1.8-1.3c0.8-0.2,1.5,0,2.2,0.4l33.7,22.2l32.9-55.6 C173.5,77.7,174.5,79.8,175.3,82z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.3,100c-0.2,2.3-0.3,4.6-0.3,7c0,0.7,0,1.5,0,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.5,61c-1.3-1.5-2.7-2.9-4.2-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.5,61l-18,30.5c-0.5,0.8-1.2,1.3-2.1,1.4c-0.9,0.1-1.8-0.2-2.4-0.9l-25-25.8L89,113.6 c-0.4,0.7-1.1,1.2-1.9,1.4c-0.8,0.2-1.6,0-2.3-0.4L55.1,93.9L42,109.2c0-0.7,0-1.5,0-2.2c0-2.4,0.1-4.7,0.3-7l10.1-11.8 c1-1.1,2.6-1.3,3.8-0.5l29.2,20.3l26.2-48c0.4-0.8,1.2-1.3,2.1-1.5c0.9-0.1,1.8,0.2,2.4,0.8l25.1,25.9l16.9-28.6 C159.8,58.1,161.1,59.5,162.5,61z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockDefault);
export default __webpack_public_path__ + "static/media/stock_default.30553f5eb8865e4f19b31680175feefa.svg";
export { ForwardRef as ReactComponent };